<template>
    <div class="cc-carriers">
        <div class="cc-cariers__header">
            <div class="cc-carriers__title">{{ translations['Carriers'] }}</div>
            <a class="cc-link cc-carriers__change" v-if="isAnyCarrierSelected" @click="unsetCarrier">{{ translations['Change carrier'] }}</a>
        </div>
        <div class="cc-carriers__main" v-if="shouldCarriersBeShown">
            <carrier v-for="carrier in carriers" :key="carrier.id_carrier" :carrier="carrier"/>
        </div>
        <div class="cc-alert cc-alert--information" v-else>
            <span>{{ translations['Please select country to show available carriers'] }}</span>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    import Carrier from "./Carrier";

    export default {
        components: {
            Carrier,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                selectedCountry: state => state.user.deliveryAddress.country,
                carriers: state => state.carriers,
                selectedCarrier: state => state.selectedCarrier,
            }),
            shouldCarriersBeShown: function () {
                return this.selectedCountry !== null && this.selectedCountry !== '' && this.carriers && this.carriers.length > 0;
            },
            isAnyCarrierSelected: function () {
                return this.selectedCarrier !== null && this.selectedCarrier !== '';
            },
        },
        methods: {
            unsetCarrier: function () {
                this.$store.dispatch('SELECT_CARRIER', null);
                this.$store.dispatch('SELECT_PAYMENT', null);
            },
        },
        name: 'Carriers',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-carriers {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-carriers__header {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-carriers__title {
            font-family: "Oswald", sans-serif;
            font-size: 25px;
            line-height: 1;
            display: inline-block;
            text-transform: uppercase;
        }

        .cc-carriers__change {
            font-weight: bold;
            margin-left: 1.5rem;
        }

        .cc-carriers__main {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: 2.5rem;
        }
    }
</style>
